'use client';

import { IcBoldClose, IconButton, Padding, Typography } from '@musinsa/mds';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import type { Platform } from '../constants/platforms';
import { PlatformSelectDropdown } from './PlatformSelectDropdown';
import { URLInputWithPrefix } from './URLInputWithPrefix';

interface Props {
  platform?: Platform;
  url: string;
  onPlatformSelect: (platform: Platform) => void;
  onUrlChange: (url: string) => void;
  onUrlClear: () => void;
  title?: string;
  showRemoveButton?: boolean;
  onRemove?: () => void;
  className?: string;
  isDropdownOpen?: boolean;
  onDropdownOpenChange?: (open: boolean) => void;
  isDuplicated?: boolean;
  urlValidationError?: string | null;
}

export const PlatformForm = ({
  platform,
  url,
  onPlatformSelect,
  onUrlChange,
  onUrlClear,
  title,
  showRemoveButton = false,
  onRemove,
  className,
  isDropdownOpen,
  onDropdownOpenChange,
  isDuplicated = false,
  urlValidationError,
}: Props) => {
  const [internalDropdownOpen, setInternalDropdownOpen] = useState(false);

  const dropdownOpen = isDropdownOpen ?? internalDropdownOpen;
  const handleDropdownOpenChange = onDropdownOpenChange ?? setInternalDropdownOpen;

  return (
    <div className={twMerge('', className)}>
      <Padding y="2" className="flex flex-col gap-2">
        {title && (
          <div className="flex justify-between items-center">
            <Typography variant="body14pxMed">{title}</Typography>
            {showRemoveButton && onRemove && (
              <IconButton size="size20x20" onClick={onRemove}>
                <IcBoldClose strokeColor="gray-500" />
              </IconButton>
            )}
          </div>
        )}

        <PlatformSelectDropdown
          value={platform}
          isOpen={dropdownOpen}
          onOpenChange={handleDropdownOpenChange}
          onSelect={onPlatformSelect}
        />
      </Padding>

      <Padding y="2" className="flex flex-col gap-2">
        <Typography variant="body14pxMed">주소를 입력해 주세요.</Typography>
        <URLInputWithPrefix
          platform={platform}
          value={url}
          onChange={onUrlChange}
          showClearButton
          onClear={onUrlClear}
        />
        {urlValidationError && (
          <Typography variant="textEtc11pxReg" colorScheme="red">
            {urlValidationError}
          </Typography>
        )}
        {!urlValidationError && isDuplicated && (
          <Typography variant="textEtc11pxReg" colorScheme="red">
            이미 가입된 계정 입니다. SNS 정보를 확인해 주세요.
          </Typography>
        )}
      </Padding>
    </div>
  );
};
